import { Sparkles, Layout, Database, BarChart3, Settings, CheckCircle2 } from "lucide-react";
import { Logo } from "./Logo";

const NAV = [
    { icon: Layout, label: "Pages", active: true },
    { icon: Database, label: "Database", active: false },
    { icon: BarChart3, label: "Analytics", active: false },
    { icon: Settings, label: "Settings", active: false },
];

const BARS = ["40%", "70%", "55%", "90%", "65%", "100%", "78%"];

export const DashboardMockup = () => (
    <div
        data-testid="dashboard-mockup"
        className="relative overflow-hidden rounded-2xl border border-white/10 bg-[#0A0A0A] shadow-[0_40px_120px_-20px_rgba(139,92,246,0.35)]"
    >
        <div className="flex h-11 items-center gap-2 border-b border-white/10 bg-[#0D0D0D] px-4">
            <span className="h-2.5 w-2.5 rounded-full bg-white/15" />
            <span className="h-2.5 w-2.5 rounded-full bg-white/15" />
            <span className="h-2.5 w-2.5 rounded-full bg-white/15" />
            <span className="mx-auto hidden font-mono text-xs text-white/35 sm:block">redeemdeals.app/builder</span>
            <span className="ml-auto flex items-center gap-1.5 rounded-full border border-[#00C2FF]/30 bg-[#00C2FF]/10 px-2.5 py-0.5 text-[10px] font-medium text-[#00C2FF] sm:ml-0">
                <span className="pulse-dot h-1.5 w-1.5 rounded-full bg-[#00C2FF]" />
                AI generating
            </span>
        </div>

        <div className="flex h-[400px] sm:h-[460px]">
            <aside className="hidden w-44 flex-col gap-1 border-r border-white/10 p-4 md:flex">
                <div className="mb-4 flex items-center gap-2 px-2">
                    <Logo size={16} />
                    <span className="font-display text-xs font-medium text-white/80">RedeemDeals</span>
                </div>
                {NAV.map((item) => (
                    <div
                        key={item.label}
                        className={`flex items-center gap-2.5 rounded-lg px-3 py-2 text-xs ${
                            item.active ? "bg-white/5 text-white" : "text-white/40"
                        }`}
                    >
                        <item.icon size={14} strokeWidth={1.5} />
                        {item.label}
                    </div>
                ))}
                <div className="mt-auto rounded-lg border border-white/10 p-3">
                    <p className="text-[10px] text-white/40">Build progress</p>
                    <div className="mt-2 h-1 overflow-hidden rounded-full bg-white/10">
                        <div className="mock-block h-full w-4/5 rounded-full bg-gradient-to-r from-[#00C2FF] to-[#8B5CF6]" style={{ animationDelay: "1s" }} />
                    </div>
                </div>
            </aside>

            <div className="relative flex-1 p-4 sm:p-6">
                <div className="flex items-center gap-3 rounded-xl border border-white/10 bg-[#050505] px-4 py-3">
                    <Sparkles size={16} strokeWidth={1.5} className="shrink-0 text-[#8B5CF6]" />
                    <span className="font-mono text-xs text-white/80 sm:text-sm">
                        <span className="typing-text">A storefront for handmade candles</span>
                        <span className="ml-0.5 inline-block h-3.5 w-[2px] bg-[#00C2FF]" style={{ animation: "caret-blink 1s steps(1) infinite" }} />
                    </span>
                </div>

                <div className="mt-4 space-y-3">
                    <div className="mock-block flex h-9 items-center gap-3 rounded-lg bg-white/5 px-3" style={{ animationDelay: "1.4s" }}>
                        <span className="h-2 w-2 rounded-full bg-[#8B5CF6]/70" />
                        <span className="h-1.5 w-16 rounded bg-white/15" />
                        <span className="ml-auto h-1.5 w-10 rounded bg-white/10" />
                        <span className="h-1.5 w-10 rounded bg-white/10" />
                        <span className="h-5 w-14 rounded-full bg-white/80" />
                    </div>

                    <div className="mock-block h-24 rounded-xl border border-white/10 bg-gradient-to-br from-[#8B5CF6]/15 to-[#00C2FF]/10 p-4 sm:h-28" style={{ animationDelay: "2.4s" }}>
                        <div className="h-2 w-1/2 rounded bg-white/25" />
                        <div className="mt-2 h-2 w-1/3 rounded bg-white/10" />
                        <div className="mt-4 h-6 w-20 rounded-full bg-white/85" />
                    </div>

                    <div className="mock-block grid grid-cols-3 gap-3" style={{ animationDelay: "3.4s" }}>
                        {[0, 1, 2].map((i) => (
                            <div key={i} className="h-20 rounded-lg border border-white/10 bg-white/5 p-2">
                                <div className="h-8 rounded bg-gradient-to-br from-[#00C2FF]/25 to-[#8B5CF6]/25" />
                                <div className="mt-2 h-1.5 w-3/4 rounded bg-white/15" />
                                <div className="mt-1.5 h-1.5 w-1/2 rounded bg-white/10" />
                            </div>
                        ))}
                    </div>

                    <div className="mock-block flex gap-3" style={{ animationDelay: "4.4s" }}>
                        <div className="flex h-24 flex-1 items-end gap-1.5 rounded-lg border border-white/10 bg-white/5 p-3">
                            {BARS.map((h, i) => (
                                <div
                                    key={i}
                                    className="w-full rounded-t bg-gradient-to-t from-[#00C2FF]/60 to-[#8B5CF6]/60"
                                    style={{ height: h }}
                                />
                            ))}
                        </div>
                        <div className="hidden h-24 w-28 flex-col justify-center gap-2 rounded-lg border border-white/10 bg-white/5 p-3 sm:flex">
                            <div className="h-1.5 w-2/3 rounded bg-white/10" />
                            <div className="h-3 w-1/2 rounded bg-white/25" />
                            <div className="h-1.5 w-3/4 rounded bg-[#00C2FF]/40" />
                        </div>
                    </div>
                </div>

                <div className="mock-block absolute bottom-4 right-4 flex items-center gap-3 rounded-xl border border-[#8B5CF6]/40 bg-[#111111] px-4 py-3 shadow-[0_10px_40px_rgba(139,92,246,0.3)]" style={{ animationDelay: "5.6s" }}>
                    <CheckCircle2 size={18} strokeWidth={1.5} className="text-[#00C2FF]" />
                    <div>
                        <p className="text-xs font-medium text-white">Your app is live</p>
                        <p className="font-mono text-[10px] text-white/40">candlestore.redeemdeals.app</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
);
